module.exports = __webpack_public_path__ + "media/images/navbar/bulle-abfecbc2810cba91e083a7cb50cf0ada.png";